export default "__VITE_ASSET__CsL6hhUP__"